import React from 'react';

import { useContainer } from 'unstated-next';

import UserRoleFilter from './UserRoleFilter';
import UserSearchForm from './UserSearchForm';
import AdminUsersContainer from '../../AdminUsersContainer';
import { type UserRole } from '../../constants/user-roles';

export interface UserFilterToolsProps {}

const UserFilterTools: React.FC<UserFilterToolsProps> = () => {
    const { setRoleFilter, setSearchText } = useContainer(AdminUsersContainer);

    const handleRoleFilterChange = (role: UserRole) => {
        setRoleFilter(role);
    };

    const onSearch = (searchText: string) => {
        setSearchText(searchText);
    };

    return (
        <>
            <UserSearchForm onSearch={onSearch} />
            <UserRoleFilter onRoleChange={handleRoleFilterChange} />
        </>
    );
};

export default UserFilterTools;
